var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin"},[(_vm.isVisible)?_c('router-view',{attrs:{"groupName":_vm.groupName},on:{"update-admin-home":_vm.updateAdminHome,"show-admin-logout-confirmation":_vm.showAdminLogoutConfirmation}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }